const STYLE_ID = 'ci-formstack-embed-fix';

// The Formstack embed writes its form into a same-origin about:blank iframe, so its
// stylesheet can't be reached from the theme's CSS. Its field rows use overflow: hidden,
// which clips the Select2 lookup dropdown (project search) out of view.
const EMBED_STYLES = `
	.ff-form-main,
	.ff-group-row,
	.ff-item-row,
	.ff-col-1,
	.ff-col-2,
	.ff-field-col {
		overflow: visible !important;
	}

	.select2-drop,
	.select2-drop-mask {
		z-index: 10000 !important;
	}
`;

class FormstackEmbed {
	constructor() {
		this.watchDuration = 30000;
		this.pollInterval = 500;
		this.startedAt = Date.now();

		this.tick = this.tick.bind(this);
		this.tick();
	}

	tick() {
		const frame = document.getElementById('ffEmbedFrame');

		if (frame) {
			this.applyStyles(frame);

			if (!frame.dataset.ciEmbedFixBound) {
				frame.dataset.ciEmbedFixBound = 'true';
				frame.addEventListener('load', () => {
					this.startedAt = Date.now();
					this.applyStyles(frame);
				});
			}
		}

		if (Date.now() - this.startedAt < this.watchDuration) {
			window.setTimeout(this.tick, this.pollInterval);
		}
	}

	applyStyles(frame) {
		let doc = null;

		try {
			doc = frame.contentDocument;
		} catch (err) {
			return;
		}

		if (!doc || !doc.head || doc.getElementById(STYLE_ID)) {
			return;
		}

		const styleEl = doc.createElement('style');

		styleEl.id = STYLE_ID;
		styleEl.textContent = EMBED_STYLES;
		doc.head.appendChild(styleEl);
	}
}

export default FormstackEmbed;
